import "@fontsource-variable/dm-sans";
import "./styles/app.css";
import "./i18n";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { env } from "./lib/env";
import { applyStoredTheme } from "./lib/theme";

applyStoredTheme();

if (env.sentryDsn) {
  Sentry.init({ dsn: env.sentryDsn, release: env.release });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
